import { render, staticRenderFns } from "./stockMoveReport.vue?vue&type=template&id=5a68d785"
import script from "./stockMoveReport.vue?vue&type=script&lang=js"
export * from "./stockMoveReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports